import React from "react";
import PropTypes from "prop-types";
import DocumentWhite from "../icons/document-white.svg";
import DocumentGrey from "../icons/document-grey.svg";

const DocumentReviewStepIcon = ({ show, completed }) => {
  const iconSrc = show || completed ? DocumentWhite : DocumentGrey;

  return (
    <div className="stepLeft">
      <img
        src={iconSrc}
        alt="Document Step Icon"
        // style={{ height: 24, width: 24 }}
      />
    </div>
  );
};



DocumentReviewStepIcon.propTypes = {
  completed: PropTypes.any,
  show: PropTypes.bool,
};

export default DocumentReviewStepIcon;
